import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from "axios";

// Mirrors ManagerNavbar.js structure exactly (same markup/classes), just
// reads the AppUser's identity instead of a Manager's.
const UserNavbar = () => {

    const [email, setEmail] = useState("")

    useEffect(() => {
        let token = null;
        try {
            const raw = localStorage.getItem("state");
            if (raw) {
                const state = JSON.parse(raw);
                token = state.auth?.token;
                if (token) {
                    // The JWT carries the email as a claim -- decode just
                    // enough to show it in the header without a network call.
                    const payload = JSON.parse(atob(token.split(".")[1]));
                    const emailClaim = payload["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
                    if (emailClaim) setEmail(emailClaim);
                }
            }
        } catch (e) {
            console.error("Token parsing failed", e);
        }
    }, [])

    const Logout = () => {
        const adminSnapshot = localStorage.getItem("adminSnapshot");
        const adminRole = localStorage.getItem("adminRole");

        if (adminSnapshot) {
            // Restore admin session
            localStorage.setItem("state", adminSnapshot);
            localStorage.setItem("isAuthenticated", "true");
            localStorage.setItem("URole", adminRole || "Admin");
            localStorage.removeItem("adminSnapshot");
            localStorage.removeItem("adminRole");
            localStorage.removeItem("AppUserId");
            window.location.href = "/";
        } else {
            // Normal logout
            localStorage.removeItem("isAuthenticated");
            localStorage.removeItem("AppUserId");
            localStorage.removeItem("URole");
            localStorage.removeItem("state");
            window.location.href = "/";
        }
    }

    return (
        <>
            <div>
                <a className="menu-toggler responsive-toggler" data-bs-toggle="collapse" data-bs-target=".navbar-collapse">
                    <span></span>
                </a>
                <div className="top-menu">
                    <ul className="nav navbar-nav pull-right">
                        <li className="dropdown dropdown-user">
                            <a className="dropdown-toggle" data-bs-toggle="dropdown" data-hover="dropdown"
                                data-close-others="true">
                                <span className="username username-hide-on-mobile" />
                                {email}
                            </a>
                            <ul className="dropdown-menu dropdown-menu-default">
                                <li>
                                    <a onClick={Logout}>
                                        <i className="icon-logout"></i> Log Out </a>
                                </li>
                            </ul>
                        </li>
                        <li className="dropdown dropdown-quick-sidebar-toggler">
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
};

export default UserNavbar;